/*
 * ALMA - Atacama Large Millimeter Array
 * Copyright (c) ESO - European Southern Observatory, 2011
 * (in the framework of the ALMA collaboration).
 * All rights reserved.
 * 
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 * 
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 * 
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA 02111-1307  USA
 */
import {ElementRef, Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AsaxScrollingService {
    private headerCanScrollLeft = new BehaviorSubject<boolean>(false);
    private headerCanScrollRight = new BehaviorSubject<boolean>(false);

    private tableCanScrollLeft = new BehaviorSubject<boolean>(false);
    private tableCanScrollRight = new BehaviorSubject<boolean>(false);

    // Use a delay of 100 milliseconds to let the UI to be updated
    // to be able to check the width of the scrollView and of the client view
    public delayedCheckScroll(filtersContainer: ElementRef<any>, component: string): void {
        setTimeout(() => {
        this.checkScroll(filtersContainer, component);
        }, 100); 
    }

    public scrollRight(filtersContainer: ElementRef<any>, component: string): void {
        filtersContainer.nativeElement.scrollTo({ left: (filtersContainer.nativeElement.scrollLeft + 150), behavior: 'smooth' });
        this.delayedCheckScroll(filtersContainer, component);
    }

    public scrollLeft(filtersContainer: ElementRef<any>, component: string): void {
        filtersContainer.nativeElement.scrollTo({ left: (filtersContainer.nativeElement.scrollLeft - 150), behavior: 'smooth' });
        this.delayedCheckScroll(filtersContainer, component);
    }

    public getHeaderCanScrollLeft() {
        return this.headerCanScrollLeft.asObservable();
    }

    public getHeaderCanScrollRight() {
        return this.headerCanScrollRight.asObservable();
    }

    public getTableCanScrollLeft() {
        return this.tableCanScrollLeft.asObservable();
    }

    public getTableanScrollRight() {
        return this.tableCanScrollRight.asObservable();
    }

    private checkScroll(filtersContainer: ElementRef<any>, component: string): void {
        if (filtersContainer?.nativeElement) {
            const container = filtersContainer.nativeElement;
            const canScrollLeft = container.scrollLeft > 0;
            const canScrollRight = container.scrollWidth > container.clientWidth && container.scrollLeft + container.clientWidth < container.scrollWidth;

            this.updateMarginForContainer(container, canScrollLeft, canScrollRight);
            this.updateCanScrollVariables(component, canScrollLeft, canScrollRight);
        }
    }
    private updateCanScrollVariables(component: string, canScrollLeft: boolean, canScrollRight: boolean) {
        switch (component) {
            case 'HeaderFiltersContainerComponent': {
                this.headerCanScrollLeft.next(canScrollLeft);
                this.headerCanScrollRight.next(canScrollRight);
                break;
            }
            case 'TableContainerComponent': {
                this.tableCanScrollLeft.next(canScrollLeft);
                this.tableCanScrollRight.next(canScrollRight);
                break;
            }
            default: 
                break;
        }
    }

    private updateMarginForContainer(container: any, canScrollLeft: boolean, canScrollRight: boolean) {
        if (!canScrollLeft) {
        container.classList.add('ms-2');
        } else {
        container.classList.remove('ms-2');
        }

        if (!canScrollRight) {
        container.classList.add('me-2');
        } else {
        container.classList.remove('me-2');
        }
    }
}

